import { render, staticRenderFns } from "./ConfigurationsSectionComponent.vue?vue&type=template&id=d90ac8d4&scoped=true"
import script from "./ConfigurationsSectionComponent.js?vue&type=script&lang=js&external"
export * from "./ConfigurationsSectionComponent.js?vue&type=script&lang=js&external"
import style1 from "./ConfigurationsSectionComponent.vue?vue&type=style&index=1&id=d90ac8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90ac8d4",
  null
  
)

export default component.exports